import { useNetwork } from '@vueuse/core';
import type { Ref } from 'vue';
import { computed, watch } from 'vue';

type UseConnectionGuardOptions = {
    isWaiting: Ref<boolean>;
    isShowingLoading: () => boolean;
    isShowingOffline: () => boolean;
    onOffline: () => void;
    onReconnected: () => void;
    onSlowConnection?: () => void;
    onFastConnection?: () => void;
};

export function useConnectionGuard(options: UseConnectionGuardOptions): void {
    const { isOnline, effectiveType } = useNetwork();

    const isSlowConnection = computed<boolean>(() => effectiveType.value === 'slow-2g' || effectiveType.value === '2g');

    watch(isOnline, (online: boolean) => {
        if (!options.isWaiting.value && !options.isShowingLoading()) {
            return;
        }

        if (!online) {
            options.onOffline();

            return;
        }

        if (!options.isShowingOffline()) {
            return;
        }

        options.onReconnected();
    });

    watch(isSlowConnection, (slow: boolean) => {
        if (!options.isWaiting.value && !options.isShowingLoading()) {
            return;
        }

        if (slow) {
            options.onSlowConnection?.();
            return;
        }

        options.onFastConnection?.();
    });
}
